export default function TightMain({ children }) {

	return (
		<main className="mx-auto max-w-4xl px-4 lg:px-0 text-[#8a8f98] py-16">
			{children}
		</main>
	)
}
